import {ChangeDetectorRef, Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {ApiService} from "../../../../services/api.service";

@Component({
  selector: 'app-automatic-file-upload',
  templateUrl: './automatic-file-upload.component.html',
  styleUrls: ['./automatic-file-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutomaticFileUploadComponent),
      multi: true
    }
  ]
})
export class AutomaticFileUploadComponent implements OnInit, ControlValueAccessor {

  @Input() type: 'document' | "image";
  @Input() maxsize: string  = "1";
  @Input() uploadURL: string = '';

  value: string;

  preview: string;

  writeFile: any;
  onChange: any = () => {}
  onTouch: any = () => {}

  constructor(public ref: ChangeDetectorRef, public api:ApiService) {
  }

  ngOnInit(): void {

  }

  onFileInput(data: any){

    const formData = new FormData();
    formData.append('image', data.target.files[0] as any);
    this.api.apiPost(this.uploadURL, formData, true).then(
      (res: any) => {
        this.value = res.Url;
        this.onChange(res.Url);
        this.ref.markForCheck();
      }
    ).catch((err: any) => {

    });

  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

}
